import { render, staticRenderFns } from "./sonDetail.vue?vue&type=template&id=4588324a&scoped=true&"
import script from "./sonDetail.vue?vue&type=script&lang=js&"
export * from "./sonDetail.vue?vue&type=script&lang=js&"
import style0 from "./sonDetail.vue?vue&type=style&index=0&id=4588324a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4588324a",
  null
  
)

export default component.exports